<template>
  <div>
    <div class="page-banner">
      <div
        class="container"
        style="
            background-image: url('https://downloads.acs.com.hk/page-headers/2017-corporate-profile.jpg?5fc8a9b6a0943');
          "
      >
        <div class="wrapper">
          <div class="content">
            <h1>
              <a class="title">Our Story</a>
            </h1>
          </div>
        </div>
      </div>
    </div>
    <div class="container corporate-profile">
      <div class="row">
        <div class="col-md-10 offset-md-1">
          <div
            class="page-content"
            itemscope
            itemtype="http://schema.org/WebPage"
          >
            <div class="">
              <div class=" form-inline text-right">
                <div class="form-group">
                  <label for="email" style="padding-right: 16px;"
                    >Translate to
                  </label>
                  <select
                    class="select-corporate-profile form-control"
                    @change="handleChange"
                  >
                    <option value="en" selected>English</option>
                    <option value="bm">Bahasa Melayu</option>
                    <option value="cn">中文</option>
                  </select>
                </div>
                <br />
                <br />
              </div>
            </div>
            <br />
            <div id="corporate-profile-content" v-if="selectedLanguage == 'en'">
              <p class="h2">
                Introduction to TBS Solutions Sdn. Bhd.
              </p>
              <p class="h4">
                Pioneering Digital Transformation with Certified Integrated
              </p>
              <p>
                Solutions Founded in 1993 as Transformative Business Solutions
                Sdn. Bhd. and renamed TBS Solutions Sdn. Bhd. in 1996, TBS
                Solutions has grown to become a leading provider of
                transformative business solutions. With over 30 years of
                experience, the company leverages cutting-edge technology and a
                commitment to quality, helping clients across various sectors
                enhance productivity, streamline operations, and achieve greater
                operational efficiency.
              </p>
              <p class="h4">Strategic Presence and Reach</p>
              <p>
                Headquartered in Penang, Malaysia, with additional offices in
                Kuala Lumpur and Brunei, TBS Solutions is strategically
                positioned to support businesses and government agencies on
                their digital transformation journeys. The company offers a
                comprehensive range of services, including system consultation,
                network infrastructures, software development, artificial
                intelligence (AI), internet of things (IoT), cloud computing,
                and cybersecurity. These services are integral to Malaysia's
                digital transformation and align with the nation’s aspirations
                for a robust digital economy.
              </p>
              <p class="h4">
                Innovative Technologies and Leadership in Government Services
              </p>
              <p>
                TBS Solutions specializes in the development of advanced
                technologies such as Biometric Fingerprint and Facial
                Recognition systems, High-precision Satellite Navigation
                Systems, Smart Card Payment Gateways, and Mobile Platforms. As a
                JPJ Authorized Vendor, TBS has created solutions that improve
                the driving test process, enhancing both safety and
                transparency, including the JPJ e-Testing System, Vehicle Data
                Lodger (VDL), and Driving Students’ Attendance Verification
                Service. These innovations play a crucial role in supporting the
                licensing practices of Malaysia's Road Transport Department
                (JPJ) while complying with national safety standards.
              </p>
              <p class="h4">Integrated Business Ecosystem</p>
              <p>
                TBS Solutions has developed a comprehensive, integrated business
                ecosystem that spans multiple industries, enhancing the digital
                landscape for sectors such as automotive, motorcycle,
                job-seeking, tourism, education, and human resource development:
              </p>
              <p>
                <span class="h6">JPJ e-Testing System:</span> Officially
                launched in March 2024 by the Minister of Transport Malaysia, YB
                Tuan Antony Loke, TBS Solutions' JPJ e-Testing System is a
                pioneering digital solution for driving test automation,
                enhancing transparency, safety, and accuracy in the testing
                process. This system is granted by JPJ to TBS Solutions Sdn.
                Bhd., positioning the company as a leader in government-backed
                driving test innovations.
              </p>
              <p>
                <span class="h6">ePandu:</span> A digital platform under the TBS
                ecosystem that provides a range of digital services for the
                driver and automobile industry. It offers convenient digital
                solutions designed to enhance the user experience for drivers,
                automotive workshops, and related industries.
              </p>
              <p>
                <span class="h6">Carser:</span> A platform that supports
                automotive workshops by helping them optimize operations and
                grow their businesses through digital solutions.
              </p>
              <p>
                <span class="h6">MyNextJob:</span> A job-seeking platform
                embedded within the ePandu ecosystem, offering employment
                opportunities across various industries, specifically aimed at
                individuals in the automotive and transportation sectors.
              </p>
              <p>
                <span class="h6">Jom Ronda:</span> A fleet management and
                vehicle tracking solution providing comprehensive insights into
                vehicle operations. It also offers users local information on
                nearby points of interest, famous local food spots, automobile
                repair workshops, and tire shops, making travel more convenient
                and informed.
              </p>
              <p>
                <span class="h6"> Talent Farm:</span> A platform that bridges
                the gap between HR departments and training courses,
                facilitating seamless training management for employees. It
                serves as a bridge between HR and skill development
                opportunities.
              </p>
              <p>
                <span class="h6">Smart Bikers:</span> A platform and app
                dedicated to all things related to motorbikes, offering services
                and resources that cater to motorbike enthusiasts and the
                broader motorbike industry.
              </p>
              <p>
                <span class="h6"> One Touch Tour:</span> A platform designed to
                modernize the tourism sector by streamlining tour booking and
                management services, providing a seamless experience for
                travelers and businesses alike.
              </p>
              <p>
                <span class="h6">SOS:</span> An emergency response service that
                ensures critical safety and support for drivers and passengers
                during accidents or unexpected events.
              </p>
              <p>
                <span class="h6">Utama Academy:</span> A training and upskilling
                initiative aimed at developing talents in various industries,
                preparing human capital for future challenges through structured
                learning and development programs. These platforms work
                synergistically to support the growth of multiple sectors,
                contributing to Malaysia's digital economy and solidifying TBS
                Solutions' leadership in innovative solutions across diverse
                industries.
              </p>
              <p></p>
              <p class="h4">
                Commitment to Quality, Certification, and Core Values
              </p>
              <p>
                TBS Solutions is committed to maintaining the highest quality
                standards, demonstrated by the attainment of ISO 9001:2015
                certification. As part of this commitment, TBS ensures that
                "Excellent customer experience is our first priority",
                reflecting the company’s focus on exceeding customer
                expectations in every service offered. TBS consistently strives
                to improve its Quality Management Systems to ensure its products
                and services meet and exceed industry standards.
              </p>
              <p class="h4">
                The company's operations are driven by its core values:
              </p>
              <p>
                <span class="h6"> Integrity:</span> Doing the right thing with
                honesty and in compliance with the law.
              </p>
              <p>
                <span class="h6"> Collaboration:</span> Achieving success by
                leveraging the talents of both internal teams and external
                partners.
              </p>
              <p>
                <span class="h6"> Adaptability:</span> Continuously evolving by
                adapting to new technologies and environments.
              </p>
              <p>
                <span class="h6">Excellence:</span> Committed to delivering
                outstanding results with high efficiency.
              </p>
              <p class="h4">Research and Development for Future Growth</p>
              <p>
                TBS Solutions is dedicated to research and development (R&D),
                continuously investing in the exploration of innovative
                technologies. This commitment ensures the company remains at the
                forefront of technological advancements, enabling clients to
                maintain a competitive edge in an ever-changing environment. TBS
                products are designed to be compatible with MYKAD, integrated
                with national systems, enhancing their relevance and usability.
              </p>
              <p class="h4">Vision for the Future</p>
              <p>
                With a clear vision of delivering vertical transformative
                business solutions through technology, TBS Solutions aims to
                provide convenience, safety, and improved quality of life. As
                Malaysia progresses towards a fully digital economy, TBS
                Solutions is poised to lead the way with innovation, leveraging
                its integrated ecosystem to deliver exceptional results across
                various industries.
              </p>

              <!-- <p>
                TBS Solutions was established in 1993 and formally known as
                Transformative Business Solutions Sdn. Bhd. and was renamed to
                TBS Solutions Sdn. Bhd. in 1996. In it 23 years of computer
                software development experiences and with its core value of
                providing Transformative Business Solutions as its business, TBS
                has helped its clients to be more productive and efficient by
                delivering creative BUSINESS SOLUTIONS its clients.
              </p>
              <br />
              <p>
                TBS’s solutions range from Manufacturing, Trading, Servicing and
                retail stores range from single outlets to nationwide multi
                chain stores enterprise companies. We deliver the most
                appropriate and cost-effective solutions. In additions, prior to
                developing a system, we access the clients’ needs and provide
                business consultancy. After developing the system, we train the
                users and make sure the system is properly implemented and
                maintained.
              </p>
              <br />
              <p>
                TBS is always kept up to date of the latest technologies and
                continuously investing in research and development (R&D) to
                deliver cutting edge solutions to its clients so that the
                clients can take the advantages of latest technology to compete
                in this highly competitive market.
              </p> -->
              <h5></h5>
            </div>

            <div v-if="selectedLanguage == 'bm'">
              <p class="h2">TBS Solutions Sdn. Bhd.</p>
              <p class="h4">
                Menerajui Transformasi Digital dengan Penyelesaian Bersepadu
                yang Disahkan
              </p>
              <p>
                Ditubuhkan pada tahun 1993 sebagai Transformative Business
                Solutions Sdn. Bhd. dan dijenamakan semula sebagai TBS Solutions
                Sdn. Bhd. pada tahun 1996, TBS Solutions telah berkembang
                menjadi penyedia utama penyelesaian perniagaan transformasi.
                Dengan lebih daripada 30 tahun pengalaman, syarikat ini
                memanfaatkan teknologi canggih dan komitmennya terhadap kualiti
                untuk membantu pelanggan dalam pelbagai sektor meningkatkan
                produktiviti, menyelaraskan operasi, dan mencapai kecekapan
                operasi yang lebih baik.
              </p>
              <p class="h4">Jangkauan Geografi dan Kedudukan Strategik</p>
              <p>
                Berasaskan di Pulau Pinang, Malaysia, dengan pejabat tambahan di
                Kuala Lumpur dan Brunei, TBS Solutions berada dalam kedudukan
                strategik untuk menyokong perniagaan dan agensi kerajaan dalam
                perjalanan transformasi digital mereka. Syarikat ini menawarkan
                pelbagai perkhidmatan komprehensif, termasuk perundingan sistem,
                infrastruktur rangkaian, pembangunan perisian, kecerdasan buatan
                (AI), internet benda (IoT), pengkomputeran awan, dan keselamatan
                siber. Perkhidmatan ini penting dalam usaha transformasi digital
                Malaysia dan sejajar dengan aspirasi negara untuk mencapai
                ekonomi digital yang kukuh.
              </p>
              <p class="h4">
                Teknologi Inovatif dan Kepimpinan dalam Perkhidmatan Kerajaan
              </p>
              <p>
                TBS Solutions mengkhususkan dalam pembangunan teknologi canggih
                seperti Sistem Biometrik Pengenalan Cap Jari dan Wajah, Navigasi
                Satelit Berketepatan Tinggi, Kad Pintar Gerbang Pembayaran, dan
                Platform Mudah Alih. Sebagai Vendor Sah JPJ, TBS telah
                membangunkan penyelesaian yang meningkatkan proses ujian memandu
                serta meningkatkan keselamatan dan ketelusan, seperti Sistem
                e-Testing JPJ, Vehicle Data Lodger (VDL), dan Perkhidmatan
                Pengesahan Kehadiran Pelajar Memandu. Inovasi-inovasi ini
                memainkan peranan penting dalam amalan pelesenan Jabatan
                Pengangkutan Jalan (JPJ) dan mematuhi piawaian keselamatan
                negara.
              </p>
              <p class="h4">Ekosistem Perniagaan Bersepadu</p>
              <p>
                TBS Solutions telah membangunkan ekosistem perniagaan yang
                komprehensif dan bersepadu yang merangkumi pelbagai industri,
                meningkatkan landskap digital untuk sektor seperti automotif,
                motosikal, pencarian kerja, pelancongan, dan pembangunan sumber
                manusia:
              </p>
              <p>
                <span class="h6"> Sistem JPJ e-Testing: </span>Dilancarkan pada
                5hb Mac 2024 oleh YB Tuan Antony Loke, Menteri Pengangkutan
                Malaysia. Sistem JPJ e-Testing daripada TBS Solutions ialah
                penyelesaian digital perintis untuk automasi ujian memandu, yang
                meningkatkan ketelusan, keselamatan, dan ketepatan dalam proses
                ujian. Sistem ini diberikan oleh JPJ kepada TBS Solutions Sdn.
                Bhd., menjadikan syarikat ini peneraju dalam inovasi ujian
                memandu yang disokong oleh kerajaan.
              </p>
              <p>
                <span class="h6"> ePandu:</span> Platform digital di bawah
                ekosistem TBS yang menyediakan pelbagai perkhidmatan digital
                untuk industri pemandu dan automotif. Ia menawarkan penyelesaian
                digital yang mudah untuk meningkatkan pengalaman pengguna bagi
                pemandu, bengkel automotif, dan industri berkaitan.
              </p>
              <p>
                <span class="h6"> Carser:</span> Platform yang membantu bengkel
                automotif mengoptimumkan operasi dan mengembangkan perniagaan
                mereka.
              </p>
              <p>
                <span class="h6"> MyNextJob:</span> Platform pencarian pekerjaan
                yang disepadukan dalam ekosistem ePandu, menawarkan peluang
                pekerjaan dalam pelbagai industri.
              </p>
              <p>
                <span class="h6"> Jom Ronda:</span> Penyelesaian pengurusan
                armada dan penjejakan kenderaan yang memberikan pandangan
                menyeluruh mengenai operasi kenderaan, serta maklumat tempatan
                seperti tempat makanan terkenal dan bengkel berdekatan.
              </p>
              <p>
                <span class="h6">One Touch Tour:</span> Platform yang direka
                untuk memodenkan sektor pelancongan melalui tempahan dan
                pengurusan lawatan yang dipermudahkan.
              </p>
              <p>
                <span class="h6"> SOS:</span> Perkhidmatan tindak balas
                kecemasan yang menyediakan keselamatan kritikal dan sokongan
                kepada pemandu dan penumpang.
              </p>
              <p>
                <span class="h6"> Utama Academy:</span> Inisiatif latihan dan
                peningkatan kemahiran yang bertujuan untuk membangunkan bakat
                dan menyediakan modal insan untuk menghadapi cabaran masa depan.
              </p>
              <p>
                Platform-platform ini berfungsi secara sinergi, menyokong
                pelbagai industri seperti automotif, pencarian pekerjaan,
                pelancongan, dan pendidikan, serta menyumbang kepada pertumbuhan
                ekonomi digital Malaysia.
              </p>
              <p class="h4">
                Komitmen terhadap Kualiti, Pensijilan, dan Nilai Teras
              </p>
              <p>
                TBS Solutions komited untuk mengekalkan standard kualiti yang
                tertinggi, yang dibuktikan melalui pensijilan ISO 9001:2015 yang
                telah diperolehi. Sebagai sebahagian daripada komitmen ini, TBS
                memastikan bahawa "Kepuasan Pelanggan adalah Keutamaan Kami",
                mencerminkan tumpuan syarikat untuk melebihi jangkaan pelanggan
                dalam setiap perkhidmatan yang diberikan. Syarikat ini sentiasa
                berusaha untuk menambah baik Sistem Pengurusan Kualitinya bagi
                memastikan produk dan perkhidmatannya memenuhi dan melebihi
                standard industri.
              </p>
              <p class="h4">
                TBS beroperasi berasaskan nilai teras yang mengarahkan kejayaan
                syarikat:
              </p>
              <p>
                <span class="h6">Integriti:</span> Melaksanakan perkara yang
                betul dengan jujur dan mematuhi undang-undang.
              </p>
              <p>
                <span class="h6"> Kolaborasi:</span> Memanfaatkan bakat dalaman
                dan luaran untuk mencapai kejayaan bersama.
              </p>
              <p>
                <span class="h6"> Kebolehsuaian:</span> Terus berkembang dengan
                menyesuaikan diri dengan teknologi dan persekitaran baharu.
              </p>
              <p>
                <span class="h6"> Kecemerlangan: </span>Komited untuk memberikan
                hasil yang luar biasa dengan kecekapan tinggi.
              </p>
              <p class="h4">
                Penyelidikan dan Pembangunan untuk Pertumbuhan Masa Depan
              </p>
              <p>
                TBS Solutions berdedikasi untuk penyelidikan dan pembangunan
                (R&D), melabur secara berterusan dalam penerokaan teknologi
                inovatif. Komitmen ini memastikan bahawa syarikat kekal di
                barisan hadapan dalam kemajuan teknologi, membolehkan pelanggan
                mengekalkan daya saing dalam persekitaran yang sentiasa berubah.
                Produk TBS direka untuk serasi dengan MYKAD dan disepadukan
                dengan sistem nasional, meningkatkan lagi relevansi dan
                kebolehgunaan mereka.
              </p>
              <p class="h4">Visi Masa Depan</p>
              <p>
                Dengan visi yang teguh untuk menyediakan penyelesaian perniagaan
                transformasi menegak melalui penerapan teknologi, TBS Solutions
                berhasrat untuk menyampaikan kemudahan, keselamatan, dan kualiti
                hidup yang lebih baik. Seiring dengan kemajuan Malaysia ke arah
                ekonomi digital penuh, TBS Solutions bersedia untuk memimpin
                dengan inovasi, menggunakan ekosistem bersepadu mereka untuk
                memberikan hasil yang luar biasa dalam pelbagai industri.
              </p>
            </div>

            <div v-if="selectedLanguage == 'cn'">
              <p class="h2">TBS Solutions有限公司</p>
              <p class="h4">通过认证的综合解决方案引领数字化转型</p>
              <p>
                TBS Solutions有限公司成立于1993年，最初名为Transformative
                Business Solutions Sdn. Bhd.，并于1996年更名为TBS Solutions Sdn.
                Bhd.。经过30多年的发展，公司已
                经成长为领先的业务转型解决方案提供商。TBS
                Solutions凭借尖端技术和对质量的承诺
                ，帮助各行业客户提高生产力、简化运营并实现更高的运营效率。
              </p>
              <p class="h4">战略性业务覆盖</p>
              <p>
                总部位于马来西亚槟城，并在吉隆坡和文莱设有办事处，TBS
                Solutions拥有战略性优势
                ，能够支持企业和政府机构的数字化转型。公司提供全面的服务，包括系统咨询、网络
                基础设施、软件开发、人工智能（AI）、物联网（IoT）、云计算和网络安全，这些服务
                对于马来西亚的数字化转型至关重要，并与该国建立强大的数字经济的目标相一致。
              </p>
              <p class="h4">创新技术与政府服务的领导地位</p>
              <p>
                TBS
                Solutions专注于开发先进技术，如生物识别指纹与面部识别系统、高精度卫星导航
                系统、智能卡支付网关和移动平台。作为JPJ授权供应商，TBS开发了提升驾驶考试流程
                的解决方案，增强了安全性与透明度，主要包括JPJ电子考试系统、车辆数据记录器（
                VDL）和驾驶学员出勤验证服务。这些创新在支持马来西亚道路交通局（JPJ）的许可证
                发放过程中发挥了关键作用，并符合国家安全标准。
              </p>
              <p class="h4">综合商业生态系统</p>
              <p>
                TBS Solutions
                已开发了一个综合的业务生态系统，涵盖多个行业，为汽车、摩托车, 求
                职、旅游、教育和人力资源发展等领域的数字化提供了增强的解决方案：
              </p>
              <p>
                <span class="h6"> JPJ e-Testing 系统：</span>
                由马来西亚交通部长陆兆福正式于2024年3月启动，TBS Solutions 的
                JPJ e-Testing
                系统是一项驾驶测试自动化的开创性数字化解决方案，提高了测试的透
                明度、安全性和准确性。该系统由JPJ授权给TBS Solutions Sdn.
                Bhd.，确立了该公司在 政府支持的驾驶测试创新中的领导地位。
              </p>
              <p>
                <span class="h6">ePandu：</span>TBS
                生态系统下的一个数字平台，为驾驶员和汽车行业提供多种数字服务。它
                提供了便捷的数字解决方案，旨在提升驾驶员、汽车维修店和相关行业的用户体验。
              </p>
              <p>
                <span class="h6">Carser:</span>
                一个帮助汽车维修厂优化运营并推动业务增长的平台。
              </p>
              <p>
                <span class="h6"> MyNextJob:</span>
                嵌入在ePandu生态系统中的求职平台，提供各行业的就业机会。
              </p>
              <p>
                <span class="h6"> Jom Ronda:</span>
                一个车队管理和车辆追踪解决方案，提供关于车辆运营的综合见解，以及
                本地信息，如附近的餐饮场所和汽车维修店。
              </p>
              <p>
                <span class="h6"> One Touch Tour:</span>
                一个旨在简化旅游行业预订和管理流程的平台。 SOS:
                提供紧急响应服务，确保司机和乘客的安全。
              </p>
              <p>
                <span class="h6"> Utama Academy:</span>
                一个旨在提高技能和培训的计划，致力于开发人才并为未来的挑战做
                好准备。
              </p>
              <p>
                这些平台协同工作，支持汽车、求职、旅游和教育等行业，同时为马来西亚数字经济的
                增长做出贡献。
              </p>
              <p class="h4">质量承诺、认证和核心价值观</p>
              <p>
                TBS Solutions致力于保持最高的质量标准，这体现在获得了ISO
                9001:2015认证。作为
                这一承诺的一部分，TBS确保**“卓越的客户体验是我们的首要任务”**，反映了公司超越
                客户期望的服务宗旨。TBS不断改进其质量管理体系，确保其产品和服务达到并超越行业
                标准。
              </p>
              <p>公司的运营基于以下核心价值观：</p>
              <p>
                <span class="h6">诚信：</span
                >以诚实和遵守法律的方式做正确的事情。
              </p>
              <p>
                <span class="h6">协作：</span
                >通过内部团队和外部合作伙伴的协作，实现成功。
              </p>
              <p>
                <span class="h6">适应性：</span
                >通过自我审查和适应新技术和环境，持续改进。
              </p>
              <p>
                <span class="h6">卓越：</span>致力于以高效的方式提供卓越的结果。
              </p>
              <p class="h4">研发投入与未来增长</p>
              <p>
                TBS
                Solutions致力于研发（R&D），并持续投资于创新技术的探索。这一承诺确保公司
                始终处于技术进步的前沿，使客户在不断变化的环境中保持竞争优势。TBS的产品设计与
                MYKAD兼容，并与国家系统集成，增强了其相关性和可用性。
              </p>
              <p class="h4">未来愿景</p>
              <p>
                通过技术提供垂直业务转型解决方案的明确愿景，TBS
                Solutions致力于提供便利、安全
                和更高的生活质量。随着马来西亚朝着全面数字经济的方向迈进，TBS
                Solutions将继续
                通过其整合的生态系统，引领创新，跨多个行业提供卓越的成果。
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--<div class="container text-center"><a href="https://www.acs.com.hk/webservice/acs/?lang=en&page=corporate-profile&id=0&type=&ip=121.121.5.105" target="_blank"><small>data source</small></a></div>-->
  </div>
</template>

<script>
export default {
  name: "OurStory",
  data: function() {
    return {
      selectedLanguage: "en"
    };
  },
  methods: {
    handleChange(event) {
      this.selectedLanguage = event.target.value;
    }
  }
};
</script>
